<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g fill="none" fill-rule="evenodd">
      <g fill="#164194">
        <g>
          <g>
            <g>
              <g>
                <path
                  d="M0 0v13.333h11.111v-9.7L6.872 0H0zM1.111 1.11h5.35L10 4.144v8.079H1.111V1.11z"
                  transform="translate(-1176 -233) translate(160 222) translate(1009 4) translate(7 7) translate(2.667 1.333)"
                />
                <path
                  fill-rule="nonzero"
                  d="M4.324 10.933L5.333 9.175 6.351 10.933 8 10.933 6.211 8.173 7.877 5.6 6.228 5.6 5.325 7.185 4.431 5.6 2.782 5.6 4.447 8.173 2.667 10.933z"
                  transform="translate(-1176 -233) translate(160 222) translate(1009 4) translate(7 7) translate(2.667 1.333)"
                />
                <path
                  d="M8.333 4.444L6.111 4.444 6.111 0.556 7.222 0.556 7.222 3.333 8.333 3.333z"
                  transform="translate(-1176 -233) translate(160 222) translate(1009 4) translate(7 7) translate(2.667 1.333)"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>